import React from "react";
import { toast } from "react-toastify";

import { CaseHistoryTable } from "src/components/case/CaseHistoryTable";
import { useApiRequest } from "src/utils/api";
import { Case } from "src/utils/api/routes/cases.api";
import { LoadingSpinner } from "src/components/shared/loading-spinner";

interface CasePageParams {
  caseId: string;
  currentData: Pick<Case, "location" | "status" | "createdAt">;
}

export const CaseHistoryTab: React.FC<CasePageParams> = props => {
  const [ loading, setLoading ] = React.useState(true);
  const [ getCaseRes, getCaseReq ] = useApiRequest("CASE-HISTORIES:get");

  // Request the case by id based off path params
  React.useEffect(() => {
    if (props.caseId) {
      getCaseReq({ pathParams: { caseId: props.caseId } });
    }
  }, [ props, getCaseReq ]);

  // Detect the response for get case by id
  React.useEffect(() => {
    if (getCaseRes.data) {
      setLoading(false);
    }

    if (getCaseRes.errorMessage) {
      toast.error(getCaseRes.errorMessage);
    }
  }, [ getCaseRes ]);

  return (
    <>
      {loading && <LoadingSpinner />}
      {getCaseRes.data?.items && (
        <CaseHistoryTable
          data={getCaseRes.data.items}
          currentData={props.currentData}
        />
      )}
    </>
  );
};
